import { render } from "./VehicleLicensePlatesDialog.vue?vue&type=template&id=c4598562&ts=true"
import script from "./VehicleLicensePlatesDialog.vue?vue&type=script&lang=ts"
export * from "./VehicleLicensePlatesDialog.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./VehicleLicensePlatesDialog.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__